import $ from 'jquery';

export default class Slideout {
  constructor () {
    this.init();
  }

  init () {
    $('[data-slideout]').each(function () {
      const that = $(this);
      const slideout = $($(this).data('slideout'));

      $(this).click(function () {
        if (slideout.hasClass('slideout--open')) {
          slideout.removeClass('slideout--open');
          $(this).trigger('slideout:closed');
        } else {
          slideout.addClass('slideout--open');
          $(this).trigger('slideout:opened');
        }

        return false;
      });

      slideout.find('.slideout__close').click(function () {
        slideout.removeClass('slideout--open');
        return false;
      });
    });
  }
}
